import { Text, TextProps } from "@chakra-ui/react";
import dayjs from "dayjs";
import { ReactNode } from "react";

import { AttributeType } from "@reflag/shared/attributeFilter";

import BooleanCell from "./BooleanCell";
import NotAvailableCell from "./NotAvailableCell";
import NumberCell from "./NumberCell";
import { OverflowTooltip } from "./OverflowTooltip";
import TimestampCell from "./TimestampCell";

type Props = {
  value: string | number | boolean | Date | null | undefined;
  compact?: boolean;
  type: AttributeType;
};

export default function DataCell({
  value,
  type,
  compact,
  ...props
}: Props & TextProps) {
  let component: ReactNode;
  if (value === undefined || value === null || value === "") {
    component = <NotAvailableCell {...props} />;
  } else if (type === "boolean") {
    // Properly parse string boolean values
    const booleanValue = value === "true" || value === true;
    component = <BooleanCell value={booleanValue} {...props} />;
  } else if (type === "date" && value instanceof Date) {
    component = <TimestampCell value={value.toISOString()} leftAlign />;
  } else if (
    type === "date" &&
    typeof value === "string" &&
    dayjs(value).isValid()
  ) {
    component = <TimestampCell value={value} leftAlign />;
  } else if (type === "number") {
    component = (
      <NumberCell compact={compact} value={Number(value)} {...props} />
    );
  } else {
    component = (
      <OverflowTooltip
        label={value.toString()}
        openDelay={300}
        placement="bottom-start"
        hasArrow
      >
        <Text fontSize="sm" {...props}>
          {value instanceof Date ? value.toISOString() : value.toString()}
        </Text>
      </OverflowTooltip>
    );
  }

  return component;
}
